import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useTrafficCount() {
  const { visible, trafficTypes, trafficShowType } = useAppSelector((state) => state.traffic);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const dataForPost = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "b4d01c04-fbe3-44d9-a9f7-adb558a133b7",
    IncludeNonServiceBranches: false,
    Parameters: {
      "a412cb92-7f01-11ef-8d00-1062eb32e4ff": trafficTypes,
      "6d875d4d-a3b0-409a-8db5-7dcb3e03d8a3": date.created_after || "2020-06-03",
      "65b42817-bf1a-4252-889a-c8d8ff40bcd5": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, trafficTypes, trafficShowType],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        console.log(res.data.Rows, "hbwttwh");
        return res.data.Rows[0];
      });
    },
    enabled: visible && trafficShowType === 2,
  });

  return { data, isLoading, refetch, isFetching };
}
